module.exports = __webpack_public_path__ + "img/bg-05.b66df614.jpg";